import { getIsNewPortalCreated } from '../store/app/selectors';
import { isPortalIdDefined } from '../store/auth/selectors';
import { Tracker } from '../store/tracking/action-creators';
import { trackGTMEvent } from '../tracking/trackGTMEvent';
import { trackGoogleAnalyticsPageView } from '../tracking/trackGoogleAnalyticsPageView';
import { EndpointKey } from './EndpointKey';
export const EndpointsSignupCompleted = {
  [EndpointKey.TrackSignupCompleted]: {
    isStateOnlyTrigger: true,
    once: true,
    stateCheck: state => getIsNewPortalCreated(state) && isPortalIdDefined(state),
    method: (state, dispatch) => new Promise(resolve => {
      dispatch(Tracker.signupCompleted());
      trackGoogleAnalyticsPageView();
      trackGTMEvent(state);
      resolve(true);
    })
  }
};